export const functions = {
  PDFiumExt_Init: [[] as const, null] as const,
  PDFiumExt_OpenFileWriter: [[] as const, 'number'] as const,
  PDFiumExt_CloseFileWriter: [['number'] as const, null] as const,
  PDFiumExt_GetFileWriterSize: [['number'] as const, 'number'] as const,
  PDFiumExt_GetFileWriterData: [
    ['number', 'number', 'number'] as const,
    null,
  ] as const,
  PDFiumExt_OpenFormFillInfo: [[] as const, 'number'] as const,
  PDFiumExt_CloseFormFillInfo: [['number'] as const, null] as const,
  PDFiumExt_InitFormFillEnvironment: [
    ['number', 'number'] as const,
    'number',
  ] as const,
  PDFiumExt_ExitFormFillEnvironment: [['number'] as const, null] as const,
  PDFiumExt_SaveAsCopy: [['number', 'number'] as const, null] as const,
  FPDF_LoadMemDocument: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDF_GetPageSizeByIndexF: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDF_GetLastError: [[] as const, 'number'] as const,
  FPDF_GetPageCount: [['number'] as const, 'number'] as const,
  FPDF_CloseDocument: [['number'] as const, null] as const,
  FPDF_GetDocPermissions: [['number'] as const, 'number'] as const,
  FPDF_GetDocUserPermissions: [['number'] as const, 'number'] as const,
  FPDF_DestroyLibrary: [[] as const, null] as const,
  FPDF_GetMetaText: [
    ['number', 'string', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFBitmap_FillRect: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDFBitmap_Create: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFBitmap_CreateEx: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFBitmap_GetBuffer: [['number'] as const, 'number'] as const,
  FPDFBitmap_GetWidth: [['number'] as const, 'number'] as const,
  FPDFBitmap_GetHeight: [['number'] as const, 'number'] as const,
  FPDFBitmap_GetFormat: [['number'] as const, 'number'] as const,
  FPDFBitmap_Destroy: [['number'] as const, null] as const,
  FPDFPageObj_Destroy: [['number'] as const, null] as const,
  FPDFPageObj_NewImageObj: [['number'] as const, 'number'] as const,
  FPDFPageObj_GetMatrix: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_SetMatrix: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_GetBounds: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObj_Transform: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    null,
  ] as const,
  FPDFImageObj_SetBitmap: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFImageObj_GetBitmap: [['number'] as const, 'number'] as const,
  FPDFPath_CountSegments: [['number'] as const, 'number'] as const,
  FPDFPath_GetPathSegment: [['number', 'number'] as const, 'number'] as const,
  FPDFPathSegment_GetType: [['number'] as const, 'number'] as const,
  FPDFPathSegment_GetPoint: [
    ['number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPathSegment_GetClose: [['number'] as const, 'boolean'] as const,
  FPDFFormObj_CountObjects: [['number'] as const, 'number'] as const,
  FPDFFormObj_GetObject: [['number', 'number'] as const, 'number'] as const,
  FPDFBookmark_GetFirstChild: [
    ['number', 'number'] as const,
    'number',
  ] as const,
  FPDFBookmark_GetNextSibling: [
    ['number', 'number'] as const,
    'number',
  ] as const,
  FPDFBookmark_Find: [['number', 'string'] as const, 'number'] as const,
  FPDFBookmark_GetTitle: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFBookmark_GetAction: [['number'] as const, 'number'] as const,
  FPDFBookmark_GetDest: [['number', 'number'] as const, 'number'] as const,
  FPDFAction_GetType: [['number'] as const, 'number'] as const,
  FPDFAction_GetFilePath: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAction_GetDest: [['number', 'number'] as const, 'number'] as const,
  FPDFAction_GetURIPath: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFDest_GetDestPageIndex: [['number', 'number'] as const, 'number'] as const,
  FPDFDest_GetView: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFDest_GetLocationInPage: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    'boolean',
  ] as const,
  FPDF_LoadPage: [['number', 'number'] as const, 'number'] as const,
  FPDF_RenderPageBitmap: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    null,
  ] as const,
  FPDF_PageToDevice: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    null,
  ] as const,
  FPDF_DeviceToPage: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    'boolean',
  ] as const,
  FPDFPage_GetAnnotCount: [['number'] as const, 'number'] as const,
  FPDFPage_GetAnnot: [['number', 'number'] as const, 'number'] as const,
  FPDFPage_CreateAnnot: [['number', 'number'] as const, 'number'] as const,
  FPDFPage_InsertObject: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPage_RemoveAnnot: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPage_GenerateContent: [['number'] as const, 'boolean'] as const,
  FPDFPage_Flatten: [['number', 'number'] as const, 'number'] as const,
  FPDF_ClosePage: [['number'] as const, null] as const,
  FPDFAnnot_GetSubtype: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetAP: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetObjectCount: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetObject: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_AppendObject: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetRect: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetRect: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetLink: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetFormFieldType: [
    ['number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormFieldFlags: [
    ['number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormFieldName: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormFieldAlternateName: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormFieldValue: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetOptionCount: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetOptionLabel: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_IsOptionSelected: [
    ['number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFAnnot_IsChecked: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetStringValue: [
    ['number', 'string', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetColor: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetLinkedAnnot: [['number', 'string'] as const, 'number'] as const,
  FPDFAnnot_GetInkListCount: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetInkListPath: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_AddInkStroke: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_RemoveInkList: [['number'] as const, 'boolean'] as const,
  FPDFAnnot_GetVertices: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetLine: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFPageObj_GetType: [['number'] as const, 'number'] as const,
  FPDFLink_GetDest: [['number', 'number'] as const, 'number'] as const,
  FPDFLink_GetAction: [['number'] as const, 'number'] as const,
  FPDFText_LoadPage: [['number'] as const, 'number'] as const,
  FPDFText_CountChars: [['number'] as const, 'number'] as const,
  FPDFText_CountRects: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_GetRect: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFText_GetCharIndexAtPos: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_GetFontSize: [['number', 'number'] as const, 'number'] as const,
  FPDFText_GetFontInfo: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_GetBoundedText: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    'number',
  ] as const,
  FPDFText_FindStart: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_FindNext: [['number'] as const, 'boolean'] as const,
  FPDFText_FindPrev: [['number'] as const, 'boolean'] as const,
  FPDFText_GetSchResultIndex: [['number'] as const, 'number'] as const,
  FPDFText_GetSchCount: [['number'] as const, 'number'] as const,
  FPDFText_FindClose: [['number'] as const, null] as const,
  FPDFText_ClosePage: [['number'] as const, null] as const,
  FPDFText_GetText: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_GetCharBox: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPage_CloseAnnot: [['number'] as const, null] as const,
  FPDFDoc_GetAttachmentCount: [['number'] as const, 'number'] as const,
  FPDFDoc_GetAttachment: [['number', 'number'] as const, 'number'] as const,
  FPDFAttachment_GetName: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAttachment_GetStringValue: [
    ['number', 'string', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAttachment_GetFile: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnAfterLoadPage: [['number', 'number'] as const, null] as const,
  FORM_OnBeforeClosePage: [['number', 'number'] as const, null] as const,
  FPDFAnnot_SetFocusableSubtypes: [
    ['number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFAnnot_GetFocusableSubtypesCount: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetFocusableSubtypes: [
    ['number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_SetFocusedAnnot: [['number', 'number'] as const, 'boolean'] as const,
  FORM_SetIndexSelected: [
    ['number', 'number', 'number', 'boolean'] as const,
    'boolean',
  ] as const,
  FORM_OnKeyDown: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnKeyUp: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnChar: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_SelectAllText: [['number', 'number'] as const, 'boolean'] as const,
  FORM_ReplaceSelection: [
    ['number', 'number', 'number'] as const,
    null,
  ] as const,
  FORM_ForceToKillFocus: [['number'] as const, 'boolean'] as const,
  FPDF_GetSignatureCount: [['number'] as const, 'number'] as const,
  FPDF_GetSignatureObject: [['number', 'number'] as const, 'number'] as const,
  FPDFSignatureObj_GetContents: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFSignatureObj_GetByteRange: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFSignatureObj_GetSubFilter: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFSignatureObj_GetReason: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFSignatureObj_GetTime: [
    ['number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFSignatureObj_GetDocMDPPermission: [
    ['number'] as const,
    'number',
  ] as const,
  FPDF_CreateNewDocument: [[] as const, 'number'] as const,
  FPDF_ImportPagesByIndex: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDF_ImportPages: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
};
